var React = require('react');

function LampDesk (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M221.78,120.28,103,239a24,24,0,0,0-6.11,23.56L149.9,448h49.92L147,263,255.72,154.22Zm236.55,67.43-78.62,78.62a55.73,55.73,0,0,0,78.62-78.62Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M320,448H64C35.58,448,9.05,466.53.7,492.16-2.52,502,5.88,512,16.26,512H367.74c10.39,0,18.78-10,15.57-19.84C375,466.53,348.42,448,320,448ZM494.41,64H346.5L301.24,18.74a64,64,0,0,0-90.5,90.5l45,45,.28.28V302.42c0,15.63,18.9,23.46,30,12.4L506.82,94C517.88,82.9,510.05,64,494.41,64Z","className":"fa-primary","key":2})]);
}

LampDesk.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = LampDesk;

LampDesk.default = LampDesk;
